
const network = require( "./network/network_api" );
import {Button} from "./button";
import Stream from "./frp/stream";
import { fieldName } from "./utils";
import { Image } from "utils";
import SETTINGS from "settings"

export default function( { uiConfig, parent, lobbyButtonContainer, spec } )
{
    const space = parent.child( "ui" );

    //all user input in current approach must be ignored by all subsequent receivers when consumed once:
    const $keyboard = parent.s( "keyboard" )
        .with( parent.s( "is_progressive_jackpot" ), ( event, pj ) => ({ event, pj }) )
        .filter( ({ pj }) => ! pj )
        .map( ({ event }) => ({ event, consumed : false }) )
    const $barrelClick = space.s( "barrelClick" ).map( () => ({ consumed : false }) );

    const $isRoulette = space.s( "isRoulette" );
    const $notRoulette = $isRoulette.map( r => ! r );

    const $notRisk = space.s( "isRisk" ).map( i => ! i );
    const $notFreegames = space.s( "isFreegames" ).map( f => ! f );
    const $isHelp = space.s( "isHelp" );
    const $notHelp = $isHelp.map( h => ! h );
    const $helpNotPaging = space.s( "helpPaging" ).map( p => ! p );
    const $notJackpot = space.s( "isJackpot" ).map( j => ! j );
    const $notBonus = space.s( "isBonus" ).map( b => ! b );

    const $gambleVisible = Stream.any(
        space.s( "riskInvitation" ),
        $notHelp,
        $notBonus
    )
    .map( merge => _.every( merge ) && spec.risks.length > 0 )

    const $canSpin = space.s( "enabled" )
        .combineLatest( space.s( "canBet" ), space.s( "canPay" ), $notFreegames )
        .map( merge => _.every( merge ) );

    const container = new PIXI.Container;
    $isRoulette.subscribe( isRoulette => container.visible = ! isRoulette );

    progressive_jackpot_panel(
        parent,
        container,
        uiConfig.progressive_jackpot_panel ||
        ( ( SETTINGS.screen.resolution.height === 768 ) ? { position : {x: (1024-949*0.7)/2, y: 596}, scale : 0.7 } : { position : {x: (800-949*0.5)/2, y: 466}, scale : 0.5 }),
        Stream.any( $notHelp, $notJackpot, $notFreegames, $notRisk, $notBonus ).map( merge => _.every( merge ) )
    )


    /* _    ____ ___  ____ _    ____
       |    |__| |__] |___ |    [__
       |___ |  | |__] |___ |___ ___]
    */

    const { frames } = uiConfig;
    function l( desc, to, v )
    {
        const label = makeFrame( desc, uiConfig.common.font );
        container.addChild( label.frame );
        if ( to ) to.subscribe( p => {
            if( p === undefined ) p = "";
            label.label.text = p;
        } );

        let $v;
        if ( v ) $v = v.length ? Stream.combineLatest( ... v ).map( merge => _.every( merge ) ) : v;
        if ( $v ) $v
            .name( space, "label_" + fieldName( frames, desc ) )
            .on( visible => label.frame.visible = visible );
    }

    l( frames.lines,     space.s( "linesValue" ),      [ $notRisk, $notHelp, $notJackpot, $notBonus ] );
    l( frames.line_bet,  space.s( "multiplierValue" ), [ $notRisk, $notHelp, $notJackpot, $notBonus ] );
    l( frames.win,       space.s( "win" ),             [ $notRisk, $notHelp, $notJackpot, $notBonus ] );
    l( frames.credits,   space.s( "credits" ),         [           $notHelp, $notJackpot, $notBonus ] );
    l( frames.total_bet, space.s( "price" ),           [ $notRisk, $notHelp, $notJackpot, $notBonus ] );


    /* ___  _  _ ___ ___ ____ _  _ ____
       |__] |  |  |   |  |  | |\ | [__
       |__] |__|  |   |  |__| | \| ___]
    */


    const { buttons } = uiConfig;
    const createdButtons = []
    /**
     * @param e stream or array of streams if button is ENABLED. Keyboard events of keys will be filtered out when button is NOT enabled.
     * @param v stream or array of streams if button is VISIBLE. Keyboard events of keys will be filtered out when button is NOT visible.
     * @param equiv What additional input may be interpreted the same as button click (when button can be clicked). Must be a stream of objects with "consumed" property originally equalling false.
     */
    function b(
        desc,
        to,
        keys,
        { e, v, equiv } = {},
        overriddenContainer
    )
    {
        createdButtons.push( desc )
        const button = makeButton( buttons[ desc ] );
        ( overriddenContainer || container ).addChild( button );

        const enabledName = "button_" + desc + "_enabled";
        const $e =
            e
            ?
            e.length
            ?
            Stream.any( ... e ).map( merge => _.every( merge ) ).name( space, enabledName )
            :
            e.map( _ => _ ).name( space, enabledName )
            :
            space.s( enabledName, true )
        $e.on( enabled => button.enabled = enabled );

        const visibleName = "button_" + desc + "_visible";
        const $v =
            v
            ?
            v.length
            ?
            Stream.any( ... v ).map( merge => _.every( merge ) ).name( space, visibleName )
            :
            v.map( _ => _ ).name( space, visibleName )
            :
            space.s( visibleName, true )
        $v.on( visible => button.visible = visible );

        const $click = space.s( "button_" + desc + "_click" )
        button.callback = () => $click.next()
        if ( desc != "autoplay" && desc != "stop" ) $click.to( space.s( "autoplayOff" ) );
        if ( keys || equiv )
        {
            let $input = $keyboard.filter( ({ event }) => _.includes( keys || [], event ) );
            $input.name( space, "button_" + desc + "_equiv" )
            if ( equiv ) equiv.to( $input );

            if ( $e ) $input = $input.with( $e, ( state, e ) => ({ state, e }) ).filter( ({ e }) => e ).map( ({ state }) => state );
            if ( $v ) $input = $input.with( $v, ( state, v ) => ({ state, v }) ).filter( ({ v }) => v ).map( ({ state }) => state );

            //all user input in current approach must be ignored by all subsequent receivers when consumed once:
            $input
                .filter( state => ! state || ! state.consumed )
                .map( state => { if ( state ) state.consumed = true; return undefined; } )
                .to( $click )
        }
        if ( to ) $click.to( to )
    }

    // KEY CODES:
    const ENTER = 13;
    const ESC   = 27;
    const SPACE = 32;
    const KEY_1 = 49;
    const F1    = 112;
    const F2    = 113;
    const F3    = 114;
    const F4    = 115;
    const F5    = 116;
    const F6    = 117;
    const F7    = 118;
    const F8    = 119;
    const F9    = 120;
    const F10   = 121;

    b( "spin",             space.s( "spin" ),               [ ENTER, SPACE, F8 ], {
        e : $canSpin,
        v : [
            space.s( "spinVisible" ),
            $notRisk,
            $notHelp,
            $notBonus
        ],
        equiv : $barrelClick
    } );
    b( "collect",          space.s( "collect" ),            [ ENTER, SPACE, F8 ], {
        e : space.s( "collectEnabled" ),
        v : [
            space.s( "collectVisible" ),
            space.s( "finishVisible" ).map( f => ! f ),
            $notHelp,
        ],
        equiv : $barrelClick
    } );
    b( "stop",             space.s( "stop" ),               [ ENTER, SPACE, F8 ], {
        e : space.s( "canInterruptBarrel" ),
        v : [
            space.s( "mayStop" ),
            $notHelp,
            $notBonus
        ],
        equiv : $barrelClick
    } );
    b( "start",            space.s( "start" ),              [ ENTER, SPACE, F8 ], {
        e : [
            space.s( "displayingWin" ).map( d => ! d ),
            space.s( "beginningFeature" ).map( b => ! b )
        ],
        v : [
            space.s( "canStartFeature" ),
            $notHelp,
            $notBonus
        ],
        equiv : $barrelClick
    } );
    b( "finish",           space.s( "finish" ),             [ ENTER, SPACE, F8 ], {
        e : [
            space.s( "enabled" ),
            space.s( "finishEnabled" ),
        ],
        v : [
            space.s( "finishVisible" ),
            $notHelp,
        ],
        equiv : $barrelClick
    } );
    b( "info",             space.s( "info" ),               [ KEY_1, F1 ],        {
        e : space.s( "canBet" ),
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "gamble",           space.s( "gamble" ),             [ F7 ],               {
        e : [
            space.s( "enabled" ),
            space.s( "finishVisible" ).map( v => ! v ),
        ],
        v : $gambleVisible
    } );
    b( "betmax",           space.s( "maxBet" ),             undefined,            {
        e : [
            space.s( "enabled" ),
            space.s( "canBet" ),
            space.s( "canMaxBet" ),
        ],
        v : [
            space.s( "canMaxBet" ).combineLatest( space.s( "canMinBet" ), ( max, min ) => max || ! min ),
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "betmin",           space.s( "minBet" ),             undefined,            {
        e : [
            space.s( "enabled" ),
            space.s( "canBet" ),
        ],
        v : [
            space.s( "canMinBet" ),
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "autoplay",         space.s( "autoplayOn" ),         [ F9 ],               {
        e : [
            space.s( "enabled" ),
            space.s( "canBet" ),
            space.s( "canPay" ),
        ],
        v : [
            $gambleVisible.map( gv => ! gv ),
            $notRisk,
            $notHelp,
            $notBonus,
            $notJackpot,
            space.s( "isAutoplay" ).map( a => ! a )
        ]
    } );
    b( "autoplayoff",      space.s( "autoplayOff" ),        [ F9 ],              {
        //should always be able to cancel autoplay:
        //e : space.s( "enabled" ),
        v : [
            space.s( "isAutoplay" ),
            $gambleVisible.map( g => ! g ),
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "menu",             parent.s( "goLobby" ),           [ ESC ],              {
        e : space.s( "enabled" )
                .combineLatest(
                    space.s( "canBet" ),
                    parent.s( "isError" ),
                    ( e, c, i ) => ( e && c ) || i
                ),
        v : $notHelp.any(
                $notJackpot,
                $notBonus,
                parent.s( "isError" ),
                $notRoulette,
                ( nh, nj, nb, e, nr ) => ( nh && nj && nb && nr ) || e
            )
    },
        lobbyButtonContainer
    );
    b( "decrease_lines",   space.s( "decreaseLines" ),      undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeLines" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "increase_lines",   space.s( "increaseLines" ),      undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeLines" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "lines",            space.s( "increaseLines" ),      undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeLines" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "decrease_linebet", space.s( "decreaseMultiplier" ), undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeMultiplier" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "increase_linebet", space.s( "increaseMultiplier" ), undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeMultiplier" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "linebet",          space.s( "increaseMultiplier" ), [ F7 ],               {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeMultiplier" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    //inside help(info) scene:
    b( "next",             space.s( "helpNext" ),           [ F4 ],               {
        e : [
            space.s( "helpCanNext" ),
            $helpNotPaging,
        ],
        v : $isHelp,
    } );
    b( "back",             space.s( "helpPrevious" ),       [ F2 ],               {
        e : [
            space.s( "helpCanPrevious" ),
            $helpNotPaging,
        ],
        v : $isHelp,
    } );
    b( "exit",             space.s( "helpExit" ),           [ F3 ],               {
        e : $helpNotPaging,
        v : $isHelp,
    } );

    //creating any other buttons present in configuration:
    for ( const desc in buttons )
    {
        if ( createdButtons.indexOf( desc ) >= 0 ) continue
        b( desc )
    }

    const k = key => $keyboard.filter( ({ event }) => key.length ? _.includes( key, event ) : event == key );

    //set lines by keyboard:
    function setLines( key, lines )
    {
        k( key )
            .withLatestFrom(
                $notHelp,
                space.s( "canBet" ),
                parent.s( "isError" ),
                ( k, notHelp, canBet, isError ) => notHelp && canBet && ! isError
            )
            .filter( can => can )
            .map( () => lines )
            .subscribe( space.s( "setLines" ) );
    }
    switch ( spec.lines_array.length )
    {
        case 1:
            break
        case 5:
            setLines( F2, 0 );
            setLines( F3, 1 );
            setLines( F4, 2 );
            setLines( F5, 3 );
            setLines( F6, 4 );
            break
        default:
            console.error( "Undefined amount of lines groups." )
    }

    const $startImpulse = space.s( "startImpulse" );
    k( [ ENTER, SPACE, F8 ] ).subscribe( $startImpulse );
    $startImpulse
        .withLatestFrom(
            parent.s( "isError" ),
            parent.s( "animating" ),
            ( key, isError, animating ) => ({ isError, animating })
        )
        .filter( ({ isError, animating }) => ! isError && ! animating )
        .map( () => undefined )
        .subscribe( space.s( "startKey" ) );

    currency(
        container,
        space.s( "credits" ),
        parent.s( "balance" ),
        $notHelp.any( $notJackpot, $notBonus, ( nh, nj, nb ) => nh && nj && nb )
    );


    return {
        space,
        ui : container,
    };
}

function makeFrame(description, fontFace) {
    const frame = new PIXI.Sprite(PIXI.utils.TextureCache[description.frame]);
    frame.position = description.position;

    const label = new PIXI.extras.BitmapText("0", {font: description.font || fontFace});

    const textAlign = description.text_align || {x:0.5, y: 0.5};

    label.anchor.set(textAlign.x, textAlign.y);
    label.position.set(description.text_position.x, description.text_position.y);

    frame.addChild(label);

    return {frame, label};
}

function makeButton(description) {

    const normalStateTexture = PIXI.utils.TextureCache[description.frames.normal] || PIXI.Texture.EMPTY,
        pressedStateTexture = PIXI.utils.TextureCache[description.frames.pressed] || PIXI.Texture.EMPTY,
        disabledStateTexture = PIXI.utils.TextureCache[description.frames.disabled || description.frames.normal] || PIXI.Texture.EMPTY,
        overStateTexture = PIXI.utils.TextureCache[description.frames.hover || description.frames.normal] || PIXI.Texture.EMPTY;

    if (!normalStateTexture) {
        console.error(`TEXTURE ${description.frames.normal} NOT FOUND`);
    }
    if (!pressedStateTexture) {
        console.error(`TEXTURE ${description.frames.pressed} NOT FOUND`);
    }
    if (!disabledStateTexture) {
        console.error(`TEXTURE ${description.frames.disabled} NOT FOUND`);
    }
    if (!overStateTexture) {
        console.error(`TEXTURE ${description.frames.hover} NOT FOUND`);
    }


    const button = new Button(normalStateTexture, overStateTexture, pressedStateTexture, disabledStateTexture);

    const position = description.position || {x:0, y:0};

    button.position.set(position.x, position.y);
    // button.visible = false;

    if (description.active_area){
        var lb = button.getLocalBounds();

        if (description.active_area.hasOwnProperty('circle')) {
            button.hitArea = new PIXI.Circle(lb.x + description.active_area.circle.x,
                lb.y + description.active_area.circle.y,
                description.active_area.circle.r);

        }
        else if (description.active_area.hasOwnProperty('ellipse')) {
            button.hitArea = new PIXI.Ellipse(lb.x + description.active_area.ellipse.x,
                lb.y + description.active_area.ellipse.y,
                description.active_area.ellipse.width,
                description.active_area.ellipse.height);
        }
        else if (description.active_area.hasOwnProperty('rectangle')) {
            button.hitArea = new PIXI.Rectangle(lb.x + description.active_area.rectangle.x,
                lb.y + description.active_area.rectangle.y,
                description.active_area.rectangle.width,
                description.active_area.rectangle.height);
        }
        else if (description.active_area.hasOwnProperty('polygon')) {
            button.hitArea = new PIXI.Polygon(description.active_area.polygon.points);
        }
    }

    return button;
}

function currency( container, $credits, $balance, $visible )
{
    const view = new PIXI.Container;
    container.addChild( view );
    $visible.subscribe( v => view.visible = v );

    // left billet
    //TODO: реализовать наличие плашки для всех игр:
    let currencyFrame
    try
    {
        currencyFrame = Image( 'currency_frame.png' )
    }
    catch(e)
    {
        console.error( "No currency graphics. Implement it." )
        return
    }
    currencyFrame.visible = false;
    view.addChild( currencyFrame );


    const offset = SETTINGS.screen.resolution.height === 768 ? 132 + 32 : 104 + 32;
    currencyFrame.position.set( 4, SETTINGS.screen.resolution.height - offset );

    const currencySignLabel = new PIXI.Text(
        '',
        new PIXI.TextStyle(
        {
            fontFamily: 'Arial',
            fontSize: 14,
            fontStyle: 'italic',
            fill: ['#ffff00']
        } )
    );
    currencySignLabel.position.set( 4, 5 );
    currencyFrame.addChild( currencySignLabel );

    const currencyValueLabel = new PIXI.Text(
        '',
        new PIXI.TextStyle(
        {
            fontFamily: 'Arial',
            fontSize: 14,
            fontWeight: 'bold',
            fill: ['#ffffff']
        } )
    );
    currencyValueLabel.position.set( 40, 5 );
    currencyFrame.addChild( currencyValueLabel );


    // right billet
    const creditPriceFrame = Image( 'currency_frame.png' )
    creditPriceFrame.visible = false;
    view.addChild( creditPriceFrame );
    creditPriceFrame.position.set( SETTINGS.screen.resolution.width - 4 - 140, SETTINGS.screen.resolution.height - offset);

    const creditPriceLabel = new PIXI.Text(
        '',
        new PIXI.TextStyle(
        {
            fontFamily: 'Arial',
            fontSize: 12,
            fontStyle: 'bold',
            fill: ['#acf4e0']
        } )
    );
    creditPriceLabel.position.set( 4, 5 );
    creditPriceFrame.addChild( creditPriceLabel );

    $balance
        .combineLatest( $credits, ( balance, credits ) => ({ balance, credits }) )
        .subscribe( ({ balance, credits }) =>
        {
            let visible = true;
            if ( ! balance.currency || ! balance.credit_price ) visible = false;
            else if ( balance.currency.visible === false || balance.currency.visible === "false" ) visible = false;
            currencyFrame.visible = creditPriceFrame.visible = visible;
            if ( ! visible ) return;

            currencySignLabel.text = balance.currency.code_name;

            currencyValueLabel.text = literal_price( balance.gameable_money, balance.currency.minor_unit )

            creditPriceLabel.text = "1 credit = " + literal_price( balance.credit_price, balance.currency.minor_unit ) + " " + balance.currency.code_name
        } );
}
export function literal_price( value, precision )
{
    value = value.toString()
    while ( value.length < precision + 1 ) value = "0" + value
    value = value.slice( 0, - precision ) + "." + value.slice( - precision )
    return value
}

function progressive_jackpot_panel( space, container, config, $visible )
{
    const ingamePanel = Image('res/common/progressive_jackpot/jp_ingame_panel.png');
    ingamePanel.position.set( config.position.x, config.position.y );
    ingamePanel.scale.set( config.scale );
    container.addChild(ingamePanel);

    const coinText = new PIXI.BitmapText('0', {font: 'jp_bronze_font'});
    coinText.position.set(222, 7);
    ingamePanel.addChild(coinText);

    const banknotesText = new PIXI.BitmapText('0', {font: 'jp_green_font'}); //
    banknotesText.position.set(401, 7);
    ingamePanel.addChild(banknotesText);

    const diamondsText = new PIXI.BitmapText('0', {font: 'jp_white_font'}); //
    diamondsText.position.set(581, 7);
    ingamePanel.addChild(diamondsText);

    const startsText = new PIXI.BitmapText('0', {font: 'jp_gold_font'}); //
    startsText.position.set(759, 7);
    ingamePanel.addChild(startsText);

    // const gui = new dat.GUI();
    // const coinFolder = gui.addFolder('coins');
    // coinFolder.add(coinText.position, 'x', 100, 500);
    // coinFolder.add(coinText.position, 'y', 0, 20);
    //
    // const banknotesFolder = gui.addFolder('banknotes');
    // banknotesFolder.add(banknotesText.position, 'x', 300, 600);
    // banknotesFolder.add(banknotesText.position, 'y', 0, 20);
    //
    // const diamondsFolder = gui.addFolder('diamonds');
    // diamondsFolder.add(diamondsText.position, 'x', 500, 800);
    // diamondsFolder.add(diamondsText.position, 'y', 0, 20);
    //
    // const starsFolder = gui.addFolder('stars');
    // starsFolder.add(startsText.position, 'x', 700, 1000);
    // starsFolder.add(startsText.position, 'y', 0, 20);


    //поллинг текущих значений джекпота:
    space.s( "progressive_jackpot" ).on( pj => {

        const precision = ( pj.currency && pj.currency.minor_unit ) ? pj.currency.minor_unit : 0;

        coinText.text = literal_price( pj.values[ 0 ], precision );
        banknotesText.text = literal_price( pj.values[ 1 ], precision );
        diamondsText.text = literal_price( pj.values[ 2 ], precision );
        startsText.text = literal_price( pj.values[ 3 ], precision );

        /*//из доки:
            "enabled": 1,                           если 0 не отображать
            "values": [                             значения
                335,                                jp6
                1952,                               jp7
                17510                               jp8
            ],
            "currency": {                           данные о валюте джекпотов  (должно быть эквивалентно валюте игрока )
                "id": 643,
                "code_name": "RUB",
                "minor_unit": 2,
                "visible": true
            }
        */
    } )

    space.s( "progressive_jackpot" )
        .any( $visible, ( pj, v ) => ({ pj, v }) )
        .on( ({ pj, v }) => ingamePanel.visible = pj.enabled && v )
}



// WEBPACK FOOTER //
// ./src/library/ui_view.es6